import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Token } from '../auth/token.model';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  readonly token = new BehaviorSubject<string | null>(
    this.storage.get('token')
  );
  readonly fullToken = new BehaviorSubject<Token | null>(
    this.storage.get('ft') ? JSON.parse(this.storage.get('ft') as string) : null
  );
  constructor(private storage: BrowserStorageService) {}

  get(): string | null {
    return this.token.value;
  }

  getFullToken(): Token | null {
    return this.fullToken.value;
  }

  set(token: Token | null): void {
    this.token.next(token?.access_token || null);
    this.fullToken.next(token);
    this.storage.remove('token');
    this.storage.remove('ft');
  }

  persist(token: Token | null): void {
    this.set(token);
    if (token) {
      this.storage.set('token', token.access_token);
      this.storage.set('ft', JSON.stringify(token));
    }
  }

  clear(): void {
    this.set(null);
  }
}
